<!--
    描述：清标的具体表格
    时间：2021-09-23
    Created by 王帅
-->
<template>
    <div class="h100">
        <vxe-table
                :loading="loading"
                border
                highlight-hover-row
                highlight-current-row
                ref="xTable"
                auto-resize
                resizable
                align="center"
                height="auto"
                size="small"
                :sort-config="{ trigger: 'cell' }"
                :cell-class-name="cellClassName"
        >
            <vxe-column type="seq" width="70" title="序号" sortable></vxe-column>
            <vxe-column
                    field="busProContractTreeName"
                    title="单位工程名称"
                    sortable
                    min-width="160"
            ></vxe-column>
            <vxe-column field="code" title="清单编码" sortable show-overflow width="130"></vxe-column>
            <!-- 控制价 -->
            <vxe-colgroup>
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="leftValue" size="small" disabled>
                        <el-option label="控制价" value="1"></el-option>
                    </el-select>
                </template>
                <!-- 合并列 -->
                <vxe-column
                        v-for="(item, index) in listData.filterArr"
                        :key="'筛选列' + index"
                        :title="item.label"
                        :field="item.key"
                        :visible="item.visible"
                        :width="item.width"
                        :min-width="item.minWidth"
                        :align="item.align"
                        :header-align="item.headerAlign"
                        :sortable="item.sortable"
                        :show-overflow="item.showOverFlow"
                        :filters="[{ data: '' }]"
                        :filter-method="item.filterMethods"
                >
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>

                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select
                                multiple
                                filterable
                                ref="filterSelect"
                                collapse-tags
                                popper-class="drop-poper"
                                :popper-append-to-body="false"
                                v-model="option.data"
                                v-for="(option, inx) in column.filters"
                                :key="item.key + inx"
                                @change="$panel.changeOption($event, !!option.data, option)"
                        >
                            <el-option
                                    v-for="(m, n) in listData[item.key]"
                                    :key="n"
                                    :label="m.text"
                                    :value="m.value"
                            ></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column
                        v-for="(item, index) in listData.normalArr"
                        :key="'筛选列2' + index"
                        :title="item.label"
                        :field="item.key"
                        :visible="item.visible"
                        :width="item.width"
                        :min-width="item.minWidth"
                        :align="item.align"
                        :header-align="item.headerAlign"
                        :sortable="item.sortable"
                        :show-overflow="item.showOverFlow"
                >
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                </vxe-column>
            </vxe-colgroup>
            <!-- 投标单位 -->
            <vxe-colgroup>
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select
                            v-model="rightValue"
                            size="small"
                            placeholder="请选择投标报价单位"
                            clearable
                            @change="onChangeUnit"
                    >
                        <el-option
                                v-for="(item, index) in tendererList"
                                :key="'tendererUnit' + index"
                                :label="item.sname"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </template>
                <!-- 合并列 -->
                <vxe-column
                        v-for="(item, index) in listData.filterArr2"
                        :key="'筛选列' + index"
                        :title="item.label"
                        :field="item.key"
                        :visible="item.visible"
                        :width="item.width"
                        :min-width="item.minWidth"
                        :align="item.align"
                        :header-align="item.headerAlign"
                        :sortable="item.sortable"
                        :show-overflow="item.showOverFlow"
                        :filters="[{ data: '' }]"
                        :filter-method="item.filterMethods"
                >
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>

                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select
                                multiple
                                filterable
                                ref="filterSelect"
                                collapse-tags
                                popper-class="drop-poper"
                                :popper-append-to-body="false"
                                v-model="option.data"
                                v-for="(option, inx) in column.filters"
                                :key="item.key + inx"
                                @change="$panel.changeOption($event, !!option.data, option)"
                        >
                            <el-option
                                    v-for="(m, n) in listData[item.key]"
                                    :key="n"
                                    :label="m.text"
                                    :value="m.value"
                            ></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column
                        v-for="(item, index) in listData.normalArr2"
                        :key="'筛选列2' + index"
                        :title="item.label"
                        :field="item.key"
                        :visible="item.visible"
                        :width="item.width"
                        :min-width="item.minWidth"
                        :align="item.align"
                        :header-align="item.headerAlign"
                        :sortable="item.sortable"
                        :show-overflow="item.showOverFlow"
                >
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                </vxe-column>
            </vxe-colgroup>

            <!-- 异常原因 -->
            <vxe-column
                    v-for="(item, index) in reasonCloumn"
                    :key="'异常原因' + index"
                    :title="item.label"
                    field="analysisResult"
                    :visible="item.visible"
                    min-width="250"
                    :align="item.align"
                    :header-align="item.headerAlign"
                    :show-overflow="item.showOverFlow"
            >
                <template #default="{ row }">
                    {{ row.analysisResult.replace(/[;；]/g,"$&\r\n") }}
                </template>
            </vxe-column>

            <!-- 说明 -->
            <vxe-column
                    v-for="(item, index) in remarkCloumn"
                    :key="'说明' + index"
                    :title="item.label"
                    :field="item.key"
                    :visible="item.visible"
                    :width="item.width"
                    :align="item.align"
                    :header-align="item.headerAlign"
            >
                <template #default="{ row }">
                    <span v-if="row.hasRemark ===1" class="blue-text cursor-pointer" @click="editRemark(row)">编辑</span>
                    <span v-else class="gray-text cursor-pointer" @click="editRemark(row)">编辑</span>
                </template>
            </vxe-column>

            <!-- 空数据时的提示 -->
            <template #empty>
                <div class="empty-box">
                    <template v-if="emptyText !== ''">
                        <p>暂无数据基准值，请在造价文件页面导入控制价，再进行数据分析对比！</p>
                        <p>
                            <vxe-button type="primary" @click="doJump">前往造价文件</vxe-button>
                        </p>
                    </template>
                    <template v-else>
                        <span>空数据</span>
                    </template>
                </div>
            </template>
        </vxe-table>

        <!-- 列过滤弹窗 -->
        <el-dialog
                :title="dialogObj.title"
                :visible.sync="dialogObj.visible"
                :width="dialogObj.width"
                :close-on-click-modal="false"
                @closed="handleClose"
        >
            <!-- 列过滤 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogObj.visible && dialogObj.type === 'filter'">
                <!-- 对比列筛选 -->
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow"
                    >控制价
                        <el-checkbox
                                class="ml10"
                                @change="handleAllChange($event, 'compareArr1')"
                                v-model="checkAll.compare1"
                        >全选
                        </el-checkbox
                        >
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox
                                v-for="(item, index) in compareArr1"
                                :label="item.key"
                                :key="'对比列1' + index"
                                v-model="item.visible"
                        >{{ item.label }}
                        </el-checkbox
                        >
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow"
                    >{{ curTendererName }}
                        <el-checkbox
                                class="ml10"
                                @change="handleAllChange($event, 'compareArr2')"
                                v-model="checkAll.compare2"
                        >全选
                        </el-checkbox
                        >
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox
                                v-for="(item, index) in compareArr2"
                                :label="item.key"
                                :key="'对比列2' + index"
                                v-model="item.visible"
                        >{{ item.label }}
                        </el-checkbox
                        >
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow"
                    >异常原因
                        <el-checkbox
                                class="ml10"
                                @change="handleAllChange($event, 'reasonCloumn')"
                                v-model="checkAll.reasons"
                        >全选
                        </el-checkbox
                        >
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox
                                v-for="(item, index) in reasonCloumn"
                                :label="item.key"
                                :key="'对比列3' + index"
                                v-model="item.visible"
                        >{{ item.label }}
                        </el-checkbox
                        >
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow"
                    >说明
                        <el-checkbox
                                class="ml10"
                                @change="handleAllChange($event, 'remarkCloumn')"
                                v-model="checkAll.remark"
                        >全选
                        </el-checkbox
                        >
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox
                                v-for="(item, index) in remarkCloumn"
                                :label="item.key"
                                :key="'对比列3' + index"
                                v-model="item.visible"
                        >{{ item.label }}
                        </el-checkbox
                        >
                    </el-col>
                </el-row>

                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogObj.visible = false" size="small"
                    >取 消
                    </el-button>
                    <el-button
                            type="primary"
                            size="small"
                            :loading="btnLoading"
                            @click="doFilter"
                    >确 定
                    </el-button>
                </div>
            </div>
            <!-- 添加备注说明 -->
            <div class="h100 notice-container" v-if="dialogObj.visible && dialogObj.type === 'remark'">
                <div class="notice-header">
                    <span>单位工程名称： <i class="bold-text">{{ currentRow.busProContractTreeName }}</i></span>
                    <span class="ml10">清单编码： <i class="bold-text">{{ currentRow.code }}</i></span>
                </div>
                <template v-if="remarkList.length > 0">
                    <p class="sub-title">其它备注： </p>
                    <div class="content-wrap">
                        <div class="notice-box" v-for="(item, index) in remarkList" :key="'remark' + index">
                            <p>
                                <i class="el-icon-user-solid"></i>
                                <span class="ml10">{{ item.userName }}</span>
                                <span class="ml10">{{ item.createDate }}</span>
                            </p>
                            <p>{{ item.remark }}</p>
                        </div>
                    </div>
                </template>

                <!-- 底部评论区域 -->
                <div slot="footer" class="notice-footer">
                    <el-input type="textarea" v-model="currentRow.newRemark" @input="$forceUpdate()"
                              placeholder="请输入修正异常项原因..." :autosize="{minRows: 2}" maxlength="200"
                              show-word-limit></el-input>
                    <div class="text-center mt20">
                        <el-button @click="dialogObj.visible = false" size="small">取 消
                        </el-button>
                        <el-button type="primary" size="small" :loading="btnLoading" @click="doPublish">发 布
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {loadData, getUnitList, getSixCalculationPrice} from "@/api/modules/clearSection.js";
    import {getRemarks, saveRemarks} from "@/api/modules/analysisDetail";

    export default {
        name: "",
        data() {
            return {
                loading: false,
                emptyText: '',
                leftValue: "1",
                rightValue: "",
                tendererList: [], // 投标单位下拉数组
                allTableData: [], // 全部数据
                // 暂存的 当前参数
                queryParams: {
                    // id: "", // 规则ID
                    rules: {},  // 规则内容
                    unitProjectIdList: [], // 当前选择的 树ID
                    tendererId: "", // 投标报价单位id
                },
                // 列过滤弹窗
                dialogObj: {
                    title: "列过滤",
                    visible: false,
                    width: "1000px",
                    type: "filter",
                    exportExcel: false,
                },
                btnLoading: false,
                allColumns: [],
                // 全选
                checkAll: {
                    compare1: true,
                    compare2: true,
                    reasons: true,
                    remark: true,
                },
                // 控制价列
                compareArr1: [
                    {
                        label: "清单名称",
                        key: "projectName",
                        visible: true,
                        width: "200",
                        minWidth: "200",
                        align: "left",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: true,
                        filterMethods: ({option, row}) => {
                            return option.data.includes(row.projectName);
                        },
                    },
                    {
                        label: "清单特征",
                        key: "projectFeatures",
                        visible: true,
                        minWidth: "250",
                        align: "left",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "计量单位",
                        key: "unit",
                        visible: true,
                        width: "110",
                        minWidth: "0",
                        align: "center",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: true,
                        filterMethods: ({option, row}) => {
                            return option.data.includes(row.unit);
                        },
                    },
                    {
                        label: "工程量",
                        key: "quantity",
                        visible: true,
                        width: "100",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "单价",
                        key: "rateCost",
                        visible: true,
                        width: "90",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "合价",
                        key: "addup",
                        visible: true,
                        width: "100",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                ],
                // 投标单位列
                compareArr2: [
                    {
                        label: "清单名称",
                        key: "tendererProjectName",
                        visible: true,
                        width: "200",
                        minWidth: "200",
                        align: "left",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: true,
                        filterMethods: ({option, row}) => {
                            return option.data.includes(row.tendererProjectName);
                        },
                    },
                    {
                        label: "清单特征",
                        key: "tendererProjectFeatures",
                        visible: true,
                        minWidth: "250",
                        align: "left",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "计量单位",
                        key: "tendererUnit",
                        visible: true,
                        width: "110",
                        minWidth: "0",
                        align: "center",
                        headerAlign: "center",
                        sortable: false,
                        showOverFlow: true,
                        needFilter: true,
                        filterMethods: ({option, row}) => {
                            return option.data.includes(row.tendererUnit);
                        },
                    },
                    {
                        label: "工程量",
                        key: "tendererQuantity",
                        visible: true,
                        width: "100",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "单价",
                        key: "tendererRateCost",
                        visible: true,
                        width: "90",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                    {
                        label: "合价",
                        key: "tendererAddup",
                        visible: true,
                        width: "100",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                        needFilter: false,
                    },
                ],
                // 异常原因
                reasonCloumn: [
                    {
                        label: "异常原因",
                        key: "analysisResult",
                        visible: true,
                        width: "200",
                        align: "right",
                        headerAlign: "center",
                        sortable: true,
                        showOverFlow: true,
                    }
                ],
                // 说明
                remarkCloumn: [
                    {
                        label: "说明",
                        key: "remark",
                        visible: true,
                        width: "100",
                        align: "center",
                        headerAlign: "center",
                        sortable: true,
                    }
                ],
                filterObj: {
                    codeArr: [], // 当前绑定的编码数组
                    codeList: [], // 全部编码数组
                    // 清单名称过滤数组
                    nameList: [],
                    // 计量单位数组
                    unitList: [],
                },
                // 备注说明
                currentRow: {
                    newRemark: ''
                }, // 当前行对象
                remarkList: []
            };
        },
        created() {
            // 获取投标单位
            this.getUnitList();
        },
        methods: {
            getOriTableData() {
                return this.$refs.xTable.tableData
            },
            showHideInfo(obj) {
                console.log(obj)
            },
            // 获取全部投标单位列表
            getUnitList() {
                getUnitList({projectId: this.curProjectId})
                    .then((res) => {
                        this.tendererList = res.data;
                    })
                    .catch((err) => {
                        this.tendererList = [];
                    });
            },

            // 切换投标单位
            onChangeUnit(val) {
                this.queryParams.tendererId = val;
                this.$emit('changeUnit')
                this.loadData();
            },

            // 滚动加载
            loadData(type) {
                let $table = this.$refs.xTable;

                // 如果没选单位工程  || this.queryParams.tendererId === ""
                if (
                    this.queryParams.unitProjectIdList.length === 0

                ) {
                    $table ? $table.loadData([]) : "";
                    return;
                }

                if (this.queryParams.tendererId === "") {     //未选投标单位信息，默认加载，控制价信息 --- zwh
                    this.getDefaultTableData().then((data) => {
                        if ($table) {
                            $table.loadData(data);
                        }
                    });
                } else {       // 选了投标单位信息，获取控制价 及 投标价，分析信息 --- zwh
                    this.getTableData(type).then((data) => {
                        if ($table) {
                            $table.loadData(data);
                        }
                    });
                }
            },
            getDefaultTableData() {
                this.loading = true;
                let query = this.$utils.clone(this.queryParams, true);
                query.priceCode = '1007002'
                return new Promise((resolve) => {
                    getSixCalculationPrice(query)
                        .then((res) => {
                            this.loading = false;
                            // 保存全部数据
                            this.allTableData = res.data;

                            if (!res.data || res.data.length === 0) this.emptyText = 'text'
                            // if(!res.data || res.data.length == 0) this.$message({message:'暂无数据基准值，请在造价文件页面导入控制价，再进行数据分析对比！', type:'warning'})
                            resolve(res.data);
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                });
            },

            // 初始获得数据
            getTableData(type) {
                this.loading = true;
                let query = this.$utils.clone(this.queryParams, true);
                query.type = (type === 1) ? 1 : 0;
                return new Promise((resolve) => {
                    loadData(query)
                        .then((res) => {
                            this.loading = false;
                            // 保存全部数据
                            this.allTableData = res.data;

                            resolve(res.data);
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                });
            },

            // 切换 全部数据/异常数据
            changeData(showAll) {
                this.loading = true;
                let _errorData =
                    this.allTableData.filter((x) => x.analysisResult !== "") || [];

                if (showAll) {
                    this.$refs.xTable.loadData(this.allTableData);
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                } else {
                    this.$refs.xTable.loadData(_errorData);
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                }
            },

            // 打开列过滤弹窗
            openFilter() {
                this.dialogObj.title = "列过滤";
                this.dialogObj.type = "filter";
                this.dialogObj.visible = true;
            },

            // 确认过滤
            doFilter() {
                this.$refs.xTable.refreshColumn();

                this.handleClose()
            },

            // 列过滤全选事件
            handleAllChange(status, type) {
                this[type].map(x => {
                    x.visible = status
                })
            },

            // 列过滤弹窗关闭
            handleClose() {
                this.dialogObj.visible = false;
                this.btnLoading = false;
            },

            // 列样式
            cellClassName({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex}) {
                let compareArr = [
                    "tendererCode",
                    "tendererProjectName",
                    "tendererProjectFeatures",
                    "tendererUnit",
                    "tendererQuantity",
                    "tendererRateCost",
                    "tendererAddup",
                ];

                if (row.analysisResult !== "" && compareArr.includes(column.property)) {
                    return "error-cell";
                }
            },

            // 点击前往造价文件
            doJump() {
                let queryParams = this.$utils.clone(this.$route.query, true)
                queryParams.tabName = 'costFile'

                this.$router.push({
                    query: queryParams
                })
            },

            // 点击编辑备注说明
            editRemark(row) {
                this.currentRow = this.$utils.clone(row, true);
                this.currentRow.newRemark = '';
                this.dialogObj.title = "备注说明";
                this.dialogObj.type = "remark";
                this.dialogObj.visible = true;
                this.getRemarkList()
            },

            // 获取备注列表
            getRemarkList() {
                let params = {
                    projectId: this.curProjectId,
                    treeId: this.currentRow.busProContractTreeId,
                    billId1: this.currentRow.id,
                    billId2: this.currentRow.billId2,
                    type: '3',
                    code: this.currentRow.code
                }
                getRemarks(params)
                    .then(res => {
                        this.remarkList = res.data
                    })
                    .catch(err => {
                    })
            },

            // 确认发布 备注
            doPublish() {
                let params = {
                    projectId: this.curProjectId,
                    treeId: this.currentRow.busProContractTreeId,
                    billId1: this.currentRow.id,
                    billId2: this.currentRow.billId2,
                    type: '3',
                    code: this.currentRow.code,
                    remark: this.currentRow.newRemark
                }
                saveRemarks(params)
                    .then(res => {
                        this.handleClose()
                        this.loadData();
                    })
                    .catch(err => {
                    })
            },

            // 获取表格数据
            getListData() {
                return this.$refs.xTable.getTableData().visibleData || []
            },

            // 清除全部条件
            clearAll() {
                this.$refs.xTable.clearAll();
            },
        },
        computed: {
            // 项目ID
            curProjectId() {
                return this.$route.query.projectId;
            },

            // 当前选择的单位
            curTendererName() {
                let _item = this.tendererList.find((x) => x.id === this.rightValue);
                return _item ? _item.sname : "投标单位";
            },

            // 需要过滤的数据(材料名称， 单位)
            listData() {
                let _filter = this.compareArr1.filter((x) => x.needFilter);
                let _noFilter = this.compareArr1.filter((x) => !x.needFilter);
                let _filter2 = this.compareArr2.filter((x) => x.needFilter);
                let _noFilter2 = this.compareArr2.filter((x) => !x.needFilter);
                return {
                    filterArr: _filter,
                    normalArr: _noFilter,
                    filterArr2: _filter2,
                    normalArr2: _noFilter2,
                    'projectName': this.filterObj.nameList,
                    'unit': this.filterObj.unitList,
                    'tendererProjectName': this.filterObj.nameList,
                    'tendererUnit': this.filterObj.unitList,
                };
            },
        },
        watch: {
            // 监听复选框变化
            compareArr1: {
                handler: function (arr) {
                    let _false = arr.find(x => x.visible === false)
                    this.checkAll.compare1 = !_false
                },
                deep: true
            },
            // 监听复选框变化
            compareArr2: {
                handler: function (arr) {
                    let _false = arr.find(x => x.visible === false)
                    this.checkAll.compare2 = !_false
                },
                deep: true
            },

            // 异常原因
            reasonCloumn: {
                handler: function (arr) {
                    let _false = arr.find(x => x.visible === false)
                    this.checkAll.reasons = !_false
                },
                deep: true
            },

            // 备注
            remarkCloumn: {
                handler: function (arr) {
                    let _false = arr.find(x => x.visible === false)
                    this.checkAll.remark = !_false
                },
                deep: true
            },
        }
    };
</script>

<style scoped lang="less">
    .check-row {
        margin-bottom: 7px;
        background-color: #a3e3ff;
        height: 35px;
        line-height: 35px;
        font-weight: 700;
        color: #333;

        .check-name {
            border-right: 1px solid #1d7f8a;
            text-align: right;
            padding-right: 15px;
        }

        .check-content {
            text-align: left;
            padding-left: 15px;
        }
    }

    .check-row:nth-of-type(2) {
        background-color: #f5f5ad;
    }

    .check-row:nth-of-type(3) {
        background-color: #ffe4c4;
    }

    .check-row:nth-of-type(4) {
        background-color: #7fffd4;
    }

    .empty-box {
        line-height: 35px;

        p:nth-of-type(1) {
            color: #ff3526;
            font-size: 14px;
        }
    }

    .blue-text {
        color: #2671cc;
    }

    .gray-text {
        color: rgba(71, 68, 72, 0.4);
    }
</style>
